<template>
    <div class="course__mask event-vertical-card-container">
        <div class="event-vertical-card-container__header p-2">
            <img :src="companyLogo" :alt="companyName">
            <span class="ml-2 font-12 fw-500">{{companyName}}</span>
        </div>
        <div class="event-vertical-card-container__cover-image-container">
            <img class="rounded-0" v-lazy="course.course_thumb_image_full" v-if="course.course_thumb_image_full"/>
            <img class="rounded-0" v-lazy="course.course_image" v-else/>
            <span class="sport-tag">{{course.sport.name}}</span>
        </div>
        <div class="mt-1 border-none event-vertical-card-container__body shadow-none h-auto">
            <p class="mb-1 fw-600 line-height-16">{{course.name}}</p>
            <div class="d-flex company-course-card__body__address">
                <i class="fa fa-map-marker-alt"></i>
                <div class="overflow-hidden ml-2">
                    <p class="font-14 line-height-17 mb-1">{{getAddress()}}</p>
                </div>
            </div>

            <div class="font-20 body__lessons m-t-20">
                <span 
                    v-for="(day, index) in days"
                    :key="index"
                    v-text="day.name"
                    class="company-course-card__body__lessons__day"
                    :class="`${isDayInCourse(day.long) ? 'results-course-card__body__lessons__day--has-lesson text-primary' : ''}`"
                ></span>
            </div>

            <div class="mb-1 mt-3 d-flex align-items-center justify-content-between">
                <p class="d-flex align-items-center font-14 mb-0 line-height-17">
                    <img src="/images/icons/user-icon__company.svg" class="mr-1">
                    <span>{{course.start_age}} - {{course.end_age}} anni</span>
                </p>

                <p class="d-flex align-items-center font-14 mb-0 line-height-17">
                    <img src="/images/icons/course-distance-mark.svg" class="mr-1">
                    <span
                        class="fw-600"
                        v-if="geoerror !== null"
                        :title="`Distanza non disponibile: $(geoerror)`"
                        style="color: #856404;background-color: #fff3cd;border-color: #ffeeba;"
                    >
                        distanza n.d.
                    </span>
                    <span 
                        v-else
                        class="fw-600"
                    >{{course.distance_from_my_position | round }} km da te</span>
                </p>
            </div>

            <div class="relative company-course-card__footer">
                <p v-if="course.disabilities.length > 0"
                    class="mt-2 d-flex font-14 mb-0 line-height-17">
                    <img src="/images/disabilita.svg" class="mr-1">
                    <span>Supporto disabilità</span>
                </p>

                <button type="button" @click="onShowDetail" class="btn btn-primary btn-block fw-600">
                    Scopri e prenota
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CompanyCourseCard',
        props: {
            geoerror: null,
            course: {
                type: Object,
                required: true
            },
            companyLogo: String,
            company: Object
        },
        data() {
            return {
                days: [
                    {name: 'L', long: 'Lunedì'},
                    {name: 'M', long: 'Martedì'},
                    {name: 'M', long: 'Mercoledì'},
                    {name: 'G', long: 'Giovedì'},
                    {name: 'V', long: 'Venerdì'},
                    {name: 'S', long: 'Sabato'},
                    {name: 'D', long: 'Domenica'}
                ]
            }
        },
        computed: {
            companyName() {
                return this.company.name || this.company.public_name
            },
            getDays() {
                let days = []
                this.course.days.forEach(i => {
                    days.push(i.day.substring(0, 3))
                })
                return _.uniq(days).join(', ')
            }
        },
        methods: {
            getAddress() {
                let address = '';

                if (this.course.municipality)
                    address = address + ' ' + this.course.municipality;

                if (this.course.province)
                    address = address + ' ' + this.course.province;

                if (this.course.route)
                    address = address + ',' + this.course.route;

                if (this.course.house_number)
                    address = address + ' ' + this.course.house_number

                if (this.course.zip)
                    address = address + ',' + this.course.zip;

                if (this.course.state)
                    address = address + ',' + this.course.state;

                return address
            },
            onShowDetail() {
                location.href = route('courses.show', this.course.slug)
            },
            isDayInCourse(day) {
                let found = false
                this.course.days.forEach(i => {
                    if (!found) {
                        found = i.day.toLowerCase().substr(0,3) === day.toLowerCase().substr(0,3)
                    }
                })

                return found
            }
        }
    }
</script>

<style scoped>
.event-vertical-card-container.course__mask {
    height:410px;
    min-height:410px;
}
.company-course-card__body__lessons__day {
    width: 32px !important;
    height: 32px !important;
    line-height: 29px;
}
.results-course-card__body__lessons__day--has-lesson {
    border-color: #FD6E00 !important;
    color: #FD6E00 !important;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/company/CompanyCourseCard.vue